/*
 * Forte by Ryann — central media configuration.
 * These now point to the client's real photos + hero video (served from /public/media).
 * The hero <video> uses HERO_VIDEO and its native HERO_POSTER while loading.
 */

export const MEDIA = {
  // ---- Hero ----
  heroVideo: "/media/hero.mp4",
  heroVideoWebm: "/media/hero.webm",
  heroPoster: "/media/hero-poster.jpg",

  // ---- Section imagery ----
  methodImage: "/media/method.jpg",
  eventsImage: "/media/events.jpg",
  studioImage: "/media/method.jpg",
  foundationImage: "/media/foundation.jpg",
  privatesImage: "/media/privates.jpg",
};
